import { useEffect, useRef, useState } from 'react';
import FaceCanvas from './FaceCanvas';
import { FaceCameraManager } from '@/helpers/faceCameraManager';
import { ICanvasElement } from '@/interface/canvas';
// import ARCaptureBtn from '@/component/common/Button/ARCaptureBtn/ARCaptureBtn';

type FaceLandmarkCanvasProps = {
  maskConfig: ICanvasElement;
};
const FaceLandmarkCanvas = ({ maskConfig }: FaceLandmarkCanvasProps) => {
  const [videoSize, setVideoSize] = useState<{
    height: number;
    width: number;
  }>();
  const videoRef = useRef<HTMLVideoElement>(null);

  const faceCameraRef = useRef<FaceCameraManager>(
    FaceCameraManager.getInstance()
  );

  const loadUserCamera = async () => {
    try {
      if (videoRef.current) {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          // height: window.innerHeight,
          // width: window.innerWidth,
        });
        videoRef.current.srcObject = stream;
        videoRef.current.onloadedmetadata = () => {
          setVideoSize({
            height: videoRef.current!.offsetHeight,
            width: videoRef.current!.offsetWidth,
          });
        };
        videoRef.current.play();
      }
    } catch (e) {
      alert('Failed to Load webcam');
    }
  };
  useEffect(() => {
    if (videoSize && videoRef.current)
      faceCameraRef.current.init(videoRef.current);
  }, [videoSize]);
  useEffect(() => {
    loadUserCamera();
  }, []);

  return (
    <div className="w-full h-full flex absolute">
      <div className="flex justify-center w-full h-full">
        <video
          className="absolute top-0 left-0 w-[100%] h-[100%] object-cover object-center"
          ref={videoRef}
          loop={true}
          muted={true}
          autoPlay={true}
          playsInline={true}
          id="tryon_face_webcam"
        ></video>
        {videoSize && (
          <FaceCanvas
            faceConfig={maskConfig}
            height={videoSize.height}
            width={videoSize.width}
          />
        )}
      </div>

      {/* <ARCaptureBtn videoId="tryon_face_webcam" /> */}
    </div>
  );
};

export default FaceLandmarkCanvas;
